export const LOCALE_NAMESPACE = {
    AUTH: 'auth',
    COMMON: 'common',
    SUBSCRIPTIONS: 'subscriptions',
};
